/**
 * Mascara CPF para exibição no admin (NFR-003).
 * Entrada: 11 dígitos sem formatação.
 */
export function maskCpf(cpf: string): string {
  if (cpf.length !== 11) return '***.***.***-**';
  return `***.***.${cpf.slice(6, 9)}-${cpf.slice(9)}`;
}
